import { render } from "./PendingList.vue?vue&type=template&id=545595e8&scoped=true"
import script from "./PendingList.vue?vue&type=script&lang=js"
export * from "./PendingList.vue?vue&type=script&lang=js"

import "./PendingList.vue?vue&type=style&index=0&id=545595e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545595e8"]])

export default __exports__